import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Kpi } from '../services/customKpiDetailsService'

export interface KpiState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  kpi: Kpi | null
}

const initialState: KpiState = {
  isLoading: true,
  error: null,
  httpStatus: null,
  kpi: null
}

const kpiSlice = createSlice({
  name: 'kpiDetails',
  initialState,
  reducers: {
    kpiLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        kpi: null
      }
    },
    kpiUpdateAction: (state, action: PayloadAction<{ data: Kpi, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        kpi: action.payload.data
      }
    },
    kpiErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        kpi: null
      }
    },
    clearKpiAction: (state) => {
      return {
        ...state,
        kpi: null
      }
    }
  }
})

export const {
  kpiLoadingAction,
  kpiUpdateAction,
  kpiErrorAction,
  clearKpiAction
} = kpiSlice.actions

export default kpiSlice.reducer
